import axios from 'axios';

// Выгрузки (XLSX, PDF) собирает бэкенд и отдает файлом: у фронта нет ни части
// данных, ни браузера для печати. Здесь только приём блоба и сохранение.

// Имя файла берем из Content-Disposition — его задает тот же бэкенд
export const downloadFile = async (url, { params, fallbackName } = {}) => {
  const res = await axios.get(url, { params, responseType: 'blob' });
  const disposition = res.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^";]+)"?/);
  const objectUrl = window.URL.createObjectURL(res.data);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = match ? match[1] : fallbackName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
};

// Ответ запрошен как blob, поэтому текст ошибки достается из него, а не из data
export const readBlobError = async (err) => {
  const blob = err.response?.data;
  if (!blob || typeof blob.text !== 'function') return '';

  try {
    const parsed = JSON.parse(await blob.text());
    return parsed.details || parsed.error || '';
  } catch {
    return '';
  }
};
